import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import "./HomePage.scss";
import GlassGlowComponent from "../GlassGlowComponent/GlassGlowComponent";
import FirefliesEffect from "../FirefliesEffect/FirefliesEffect";
import heroMobile from "../../assets/hero-mobile.png";
import { isMobileUserAgent } from "../../utils/isMobileUserAgent";

interface HomePageProps {}

interface HomePageState {}

class HomePage extends Component<HomePageProps, HomePageState> {
  constructor(props: HomePageProps) {
    super(props);
    this.state = {};
  }

  private renderHeroCopyAndCta(): React.JSX.Element {
    return (
      <>
        <h1 className="home-page-title">
          AI Email Ajent.
          <br />
          Just CC it — it gets <br /> the thread moving.
        </h1>

        <ul className="home-page-copy">
          <li>No app.</li>
          <li>No installation.</li>
          <li>Works wherever email works.</li>
          <li>Handles coordination, scheduling, and follow-ups.</li>
          <li>And... it doesn&apos;t rummage your inbox like a curious raccoon — it only sees the threads it&apos;s CC&apos;d on.</li>
        </ul>

        <div className="home-page-actions">
          <NavLink
            to="/dashboard/login"
            className="home-page-button home-page-button--primary noise-mask"
          >
            Start free
          </NavLink>
          <div className="home-page-cta-hint" aria-hidden="true">
            <div className="home-page-cta-hint-title">Give it a spin,</div>
            <div className="home-page-cta-hint-sub">30 email threads on us.</div>
          </div>
        </div>
      </>
    );
  }

  private renderDesktop(): React.JSX.Element {
    return (
      <div className="home-page home-page--desktop">
        <div className="home-page-bg" aria-hidden="true" />
        <div className="home-page-content">
          <section className="home-page-hero">
            <div className="home-page-hero-left">{this.renderHeroCopyAndCta()}</div>

            <GlassGlowComponent>
              <img
                className="glass-glow-hero-image"
                src="/assets/hero-image.png"
                alt="Email Ajent product preview"
              />
            </GlassGlowComponent>
          </section>
        </div>
        <FirefliesEffect />
      </div>
    );
  }

  private renderMobile(): React.JSX.Element {
    return (
      <div className="home-page home-page--mobile">
        <div className="home-page-bg" aria-hidden="true" />
        <div className="home-page-content">
          <section className="home-page-hero">
            <div className="home-page-hero-left">{this.renderHeroCopyAndCta()}</div>

            <GlassGlowComponent>
              <img
                className="glass-glow-hero-image glass-glow-hero-image--mobile"
                src={heroMobile}
                alt="Email Ajent product preview"
              />
            </GlassGlowComponent>
          </section>
        </div>
        <FirefliesEffect />
      </div>
    );
  }

  render(): React.JSX.Element {
    return isMobileUserAgent() ? this.renderMobile() : this.renderDesktop();
  }
}

export default HomePage;
